import UserCoreBadgeContainer from './UserCoreBadge.container';
import UserCoreBadge from './UserCoreBadge';
export default UserCoreBadgeContainer(UserCoreBadge);
//# sourceMappingURL=index.js.map